import { AgentStatus } from '@21k/shared';

import { normalizeAgentStatus, STATUS_CONFIG } from '../utils/agentStatus';

type Props = {
  status: string | null | undefined;
  className?: string;
};

export default function AgentStatusBadge({ status, className = '' }: Props) {
  const normalized = normalizeAgentStatus(status);
  const cfg = STATUS_CONFIG[normalized];

  return (
    <span
      className={`agent-status-badge ${className}`.trim()}
      style={{ color: cfg.color }}
    >
      <span className="agent-status-dot" aria-hidden>{cfg.dot}</span>
      {cfg.label}
    </span>
  );
}
